module.exports = __webpack_public_path__ + "static/socials_ig-61f1c5a06860e3fab7e7018cfdbe1625.png";